import { Button } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  isUploadingCsv: boolean;
  onUploadFile: (file: File) => void;
};
const UploadTemplateSection = ({ isUploadingCsv, onUploadFile }: Props) => {
  return (
    <div className="upload-button-wrapper">
      <Button
        type={'submit'}
        isProcessing={isUploadingCsv}
        replaceContentWhenProcessing
        size="sm"
        className="min-w-52"
      >
        <UntitledIcon name="upload-01.3" className="mr-2 h-5 w-5" />
        <span>Upload</span>
      </Button>
      <label htmlFor={`file-upload`}></label>
      <input
        id={'file-upload'}
        type="file"
        accept=".csv"
        onChange={(e) => {
          // prevent file upload if mid-validate/upload
          if (!isUploadingCsv && e?.target?.files?.[0]) {
            onUploadFile(e.target.files[0]);
          }
          // Allow uploading of the same file
          if (e.target && e.target.value) {
            e.target.value = '';
          }
        }}
        hidden
      ></input>
    </div>
  );
};

export default UploadTemplateSection;
